export const transformRequestGenerateAiEmail = ({ destination, draftSubject, draftBody, userInquiry }) => ({
  target: destination,
  draft_subject_user: draftSubject,
  draft_body_user: draftBody,
  user_inquiry: userInquiry,
})
